<app-generic-modal (closeEvent)="close()"
  (primaryActionEvent)="confirm()"
  (secondaryActionEvent)="cancel()"
  [alertNotificationSeverity]="$safeNavigationMigration(modalConfiguration?.alertNotificationSeverity)"
  [isLoading]="$safeNavigationMigration(modalConfiguration?.isLoading)"
  [primaryActionEnabled]="enablePrimaryButton"
  [primaryActionTitle]="$safeNavigationMigration(modalConfiguration?.primaryActionTitle)"
  [secondaryActionTitle]="$safeNavigationMigration(modalConfiguration?.secondaryActionTitle)"
  [title]="$safeNavigationMigration(modalConfiguration?.title)">
  <div [ngStyle]="{'width.px': modalBodyWidth}" class="confirm-modal-body-wrapper">

    @if (showModalBodyTitle) {
      <p class="confirm-modal-body-title"
      data-cy="confirm-modal-body-title">{{modalConfiguration?.body?.title}}</p>
    }

    @if (showModalBodySubtitle) {
      @if (isSubtitleString()) {
        <p class="confirm-modal-body-subtitle"
        data-cy="confirm-modal-body-subtitle">{{modalConfiguration?.body?.subtitle}}</p>
      } @else {
        @for (line of modalConfiguration?.body.subtitle; track line) {
          <div
            class="confirm-modal-body-subtitle-entry"
          data-cy="confirm-modal-body-subtitle-entry">{{line}}</div>
        }
      }
    }

    @if (showModalBodyManualChecks) {
      @if (showModalCheckTitle) {
        <p class="confirm-modal-manual-checks-title"
        data-cy="confirm-modal-manual-checks-title">{{modalConfiguration?.body?.manualChecks?.title}}</p>
      }
      @for (option of manualChecks; track option) {
        <div class="confirm-modal-manual-check-wrapper"
          data-cy="confirm-modal-manual-check-wrapper">
          <input (change)="toggleManualCheck(option)"
            [checked]="option.checked"
            [id]="option.id"
            class="confirm-manual-check-input"
            data-cy="confirm-modal-manual-check-input"
            type="checkbox">
          <label [for]="option.id"
            class="confirm-manual-check-label"
            data-cy="confirm-modal-manual-check-label"
          [innerHTML]="option.text"></label>
        </div>
      }
    }

    @if (showNotes) {
      <div class="confirm-modal-notes-wrapper">
        @if (labelNotes) {
          <div class="confirm-modal-notes-label"
          data-cy="confirm-modal-notes-label">{{modalConfiguration?.body?.notes?.labelNotes}}</div>
        }
        <app-input-textarea
          #inputTextArea
          (inputValueChange)="notesValueChange($event)"
          [height]="notesTextareaHeight"
          [initialValue]="$safeNavigationMigration(modalConfiguration?.body?.notes?.notesValue)"
          [maxLength]="$safeNavigationMigration(modalConfiguration?.body?.notes?.maxNumberCharacters)"
          [placeholder]="$safeNavigationMigration(modalConfiguration?.body?.notes?.placeholder)"
        baseCypressTag="confirm-modal-text-area"></app-input-textarea>
      </div>
    }

  </div>
</app-generic-modal>
